"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@zapier/theme");
const Media = {
    Desktop: `@media ${theme_1.Screen.queries.desktopPlus}`,
};
exports.default = Media;
